import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { useEffect, useState } from 'react';

const qrcodeRegionId = "html5qr-code-full-region";

const createConfig = (props) => {
    let config = {};
    if (props.fps) {
        config.fps = props.fps;
    }
    if (props.qrbox) {
        config.qrbox = props.qrbox;
    }
    if (props.aspectRatio) {
        config.aspectRatio = props.aspectRatio;
    }
    return config;
};

function toHtml5QrcodeCameraScanConfig(config) {
    return {
        fps: config.fps,
        qrbox: config.qrbox,
        aspectRatio: config.aspectRatio,
        disableFlip: config.disableFlip,
        videoConstraints: {facingMode: "user"},
        formatsToSupport: "QR_CODE"
    };
}
function success(decodedText, result) {
    console.log(decodedText)
}

const Html5QrcodePlugin = (props) => {
    useEffect( () => {
        if (!(props.qrCodeSuccessCallback)) {
            throw "qrCodeSuccessCallback is required callback.";
        }

        let html5Qrcode = null;
        let started = false;

        const startScanner = async () => {
            try {
                // If another component holds the camera, do not start
                if (window.__cameraInUse) {
                    console.warn('Camera already in use, QR scanner will not start.');
                    return;
                }

                html5Qrcode = new Html5Qrcode(qrcodeRegionId, {formatsToSupport:[Html5QrcodeSupportedFormats.QR_CODE]});

                await html5Qrcode.start(
                  {facingMode:"user"},
                  createConfig(props),
                  props.qrCodeSuccessCallback
                );

                // mark camera owned by this scanner
                window.__cameraInUse = true;
                started = true;
            } catch (err) {
                console.error('Html5Qrcode start failed:', err);
                // ensure flag is not left set
                window.__cameraInUse = false;
            }
        };

        startScanner();

        return () => {
            (async () => {
                try {
                    if (html5Qrcode) {
                        // stop() rejects if not started; guard with started
                        if (started) {
                            await html5Qrcode.stop();
                        }
                        try { html5Qrcode.clear(); } catch(e){}
                    }
                } catch (stopErr) {
                    console.warn('Html5Qrcode stop/clear failed:', stopErr);
                } finally {
                    // release global flag
                    window.__cameraInUse = false;
                }
            })();
        };
    }, []); // keep original empty deps

    return (
        <div id={qrcodeRegionId} />
    );
};

export default Html5QrcodePlugin;
